<template>
    <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
            <span class="card-title">推荐组</span>
            <div style="float:right;">
                <el-date-picker class="date_range mr8" @change="getRecommendData" v-model="range" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
        </div>
        <div class="chart-data-dimension">
            <el-table class="chart-data-table" v-loading="loading" :data="tableData" height="300" style="width: 100%">
                <el-table-column prop="user" label="姓名" align="center">
                    <template slot-scope="scope">
                        {{scope.row.user.realname}}
                    </template>
                </el-table-column>
                <el-table-column prop="callernumber" label="分机号" align="center"></el-table-column>
                <el-table-column prop="totals" label="呼叫总数" align="center"></el-table-column>
                <el-table-column prop="success" label="接通数量" align="center"></el-table-column>
                <el-table-column prop="seconds" label="呼叫总时长" align="center">
                    <template slot-scope="scope">
                        {{secondsToHms(scope.row.seconds)}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </el-card>

</template>
<script>
import {
    secondsToHms
} from '@/utils/common.js';
import * as api from '@/api/module'
export default {
    props: {
        initRecommendData: {
            Type: Array,
            default: []
        }
    },
    watch: {
        initRecommendData: {
            handler(val) {
                console.log(val)
                this.tableData = val
            },
            deep: true,
            // 第一次渲染直接执行一次监听器
            immediate: true,
        }
    },
    data() {
        return {
            tableData: [],
            range: [],
            loading: false,
        }
    },
    beforeCreate() {
        this.secondsToHms = secondsToHms;

    },
    methods: {
        getRecommendData() {
            let _this = this;
            _this.loading = true
            let query = {
                range: _this.range,
            }
            api.recommend(query)
                .then(res => {
                    if (res.code == 200) {
                        _this.tableData = res.data.wash;
                        _this.loading = false
                    } else {
                        _this.$message.error(res.msg);
                        return;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },


    }
}
</script>